<div class="centerWrap mt-4 pt-2">
    <div class="adminInnerHead pt-2">
        <div class="row">
            <div class="col-12 col-md-6">
                <!-- <div class="userCouresLatest pb-2">
                    <h3>Contact Us</h3>
                    <span>Get in touch with us in case of queries</span>
                </div> -->
                <div class="formHeading">
                    <h2>Contact Us</h2>
                    <p>Get in touch with us in case of queries</p>
                </div>
            </div>
        </div>
    </div>
    <br>
    <form [formGroup]="contactForm" class="col-10" style="margin-left: 9%;">
        <div class="formArea">
            <div class="col-12 col-md-6">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>First Name</mat-label>
                        <input matInput formControlName="first_name"
                            [ngClass]="{ 'is-invalid': submitted && f.first_name.errors }" autocomplete="off">
                    </mat-form-field>
                    <div *ngIf="submitted && f.first_name.errors">
                        <span *ngIf="f.first_name.errors.required" class="text-mute text-danger errorText">This field is
                            required</span>
                        <span *ngIf="f.first_name.errors.pattern" class="text-mute text-danger errorText">Only alphabets
                            are allowed</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>Last Name</mat-label>
                        <input matInput formControlName="last_name"
                            [ngClass]="{ 'is-invalid': submitted && f.last_name.errors }" autocomplete="off">
                    </mat-form-field>
                    <div *ngIf="submitted && f.last_name.errors">
                        <!-- <span *ngIf="f.last_name.errors.required" class="text-mute text-danger errorText">This field is required</span> -->
                        <span *ngIf="f.last_name.errors.pattern" class="text-mute text-danger errorText">Only alphabets
                            are allowed</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>Email ID</mat-label>
                        <input matInput formControlName="email"
                            [ngClass]="{ 'is-invalid': submitted && f.email.errors }" autocomplete="off">
                    </mat-form-field>
                    <div *ngIf="submitted && f.email.errors">
                        <span *ngIf="f.email.errors.required" class="text-mute text-danger errorText">This field is
                            required</span>
                        <span *ngIf="f.email.errors.pattern" class="text-mute text-danger errorText">Enter valid
                            email</span>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                <div class="commanInput">
                    <mat-form-field class="example-full-width">
                        <mat-label>Phone Number</mat-label>
                        <input matInput formControlName="phone"
                            [ngClass]="{ 'is-invalid': submitted && f.phone.errors }" autocomplete="off">
                    </mat-form-field>
                    <div *ngIf="submitted && f.phone.errors">
                        <span *ngIf="f.phone.errors.required" class="text-mute text-danger errorText">This field is
                            required</span>
                        <span *ngIf="f.phone.errors.pattern" class="text-mute text-danger errorText">Only number allowed
                        </span>
                        <span *ngIf="f.phone.errors.minLength" class="text-mute text-danger errorText">Please enter
                            mininmum 10 digit</span>
                            <span class="text-mute text-danger errorText" *ngIf="phoneError =='Phone already exists.'">{{ phoneError}}</span>
                            <span class="text-mute text-danger errorText" *ngIf="phoneError =='Please input valid phone number'">{{ phoneError}}</span>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-12">
                <div class="form-group">
                    <textarea class="form-control" maxlength="250" #comment placeholder="Message"
                        formControlName="message"></textarea>
                    <mat-hint align="end">{{comment.value.length}} / 250 characters</mat-hint>
                    <div *ngIf="submitted && f.message.errors">
                        <span *ngIf="f.message.errors.required" class="text-mute text-danger errorText">This field is
                            required</span>
                    </div>
                </div>
            </div>
            <div class="d-flex w-100 align-items-center justify-content-center">
                <button type="submit" class="btn btn-primary" (click)="contactUs()">Submit
                    query</button>
            </div>

        </div>
        <input type="hidden" (click)="open(update)" id="successMsg">
    </form>
    <br>
    <div class="showUsers">
        <h3>Past Queries</h3>
    </div>
    <br>
    <div class="tableWrap">
        <table class="mat-elevation-z8 w-100">
            <thead>
                <tr>
                    <th>Submitted on</th>
                    <th>Message</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <!--class="selectTr"-->
                <tr *ngFor="let values of userData; let i = index">
                    <td>
                        {{values.created_dttm | date:'shortTime'}} &nbsp; <span *ngIf="values.created_dttm"> |</span> &nbsp;{{values.created_dttm | date:'d MMM, y'}}
                    </td>
                    <td>
                        {{values.message}}
                    </td>
                    <td *ngIf="values.status==1" style="color: #6A8AE2;">New</td>
                    <td *ngIf="values.status==2" style="color: #3AB564;">Resolved</td>
                    <td *ngIf="values.status==3" style="color: #FEAF38;">Viewed</td>
                </tr>
                <tr style="background-color: white;" class="selectTr" *ngIf="(userData && userData.length == 0)">
                    <td [attr.colspan]="4">No Record found.</td>
                </tr>
            </tbody>
        </table>
    </div>
    <br>
    <br>
    <br>
    
</div>
<ng-template #update let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Query Status </h6>
                <p class="size18">Query submitted successfully.</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>